import type { SVGProps } from 'react';

export default function MoneyPlus(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5286_207)">
        <path
          d="M10.3 17.2505H6.75C5.64543 17.2505 4.75 16.3551 4.75 15.2505V8.75049C4.75 7.64592 5.64543 6.75049 6.75 6.75049H17.25C18.3546 6.75049 19.25 7.64592 19.25 8.75049V11.3"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 12.0005C13 12.5528 12.5523 13.0005 12 13.0005C11.4477 13.0005 11 12.5528 11 12.0005C11 11.4482 11.4477 11.0005 12 11.0005C12.5523 11.0005 13 11.4482 13 12.0005Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.05 15V19.5M19.3 17.25L14.8 17.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5286_207">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
